var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComposeIcon = function SvgComposeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "#5c34cd",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.7a.3.3 0 0 0 .3.3h1.4a.3.3 0 0 0 .3-.3V12h4.7a.3.3 0 0 0 .3-.3v-1.4a.3.3 0 0 0-.3-.3H12V5.3a.3.3 0 0 0-.3-.3h-1.4a.3.3 0 0 0-.3.3V10H5.3a.3.3 0 0 0-.3.3v1.4a.3.3 0 0 0 .3.3H10z"
  })));
};
export default SvgComposeIcon;